import { render, staticRenderFns } from "./TestimonyModal.vue?vue&type=template&id=776c1494&"
import script from "./TestimonyModal.vue?vue&type=script&lang=js&"
export * from "./TestimonyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports